export default __webpack_public_path__ + "static/media/my-activity.a257d6af.svg";